import { styled } from '../../../../../modules';

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const Label = styled.label<{ $labelColor: string }>`
    font-size: 12px;
    font-weight: 700;
    color: ${({ $labelColor }) => $labelColor};
`;

export const InputWrapper = styled.div`
    position: relative;
`;

export const Input = styled.input`
    width: 100%;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #ccc;
    padding: 0 32px 0 10px;
    font-size: 14px;
    font-family: inherit;
    color: #333;
    background-color: rgba(25, 36, 126, 0.02);

    &:focus {
        outline: none;
        border-color: #363843;
        background-color: rgba(107, 109, 122, 0.07);
    }

    &::placeholder {
        color: #999;
    }
`;

export const ChevronIcon = styled.span<{ $open: boolean }>`
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%) ${({ $open }) => ($open ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: transform 0.15s ease;
    pointer-events: none;
    display: flex;
    align-items: center;
    color: #666;
`;

export const Dropdown = styled.ul`
    position: absolute;
    z-index: 20;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    max-height: 240px;
    overflow-y: auto;
    margin: 0;
    padding: 4px;
    list-style: none;
    background-color: #ffffff;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
`;

export const DropdownItem = styled.li`
    padding: 10px 10px;
    font-size: 13px;
    color: #333;
    border-radius: 6px;
    cursor: pointer;

    &:active {
        background-color: #eeeeee;
    }

    @media (hover: hover) {
        &:hover {
            background-color: #f2f2f2;
        }
    }
`;

export const DropdownItemCode = styled.span`
    font-weight: 700;
    color: #666;
    margin-right: 6px;
`;

export const DropdownEmpty = styled.li`
    padding: 10px;
    font-size: 13px;
    color: #999;
    text-align: center;
`;

export const OtherOption = styled(DropdownItem)`
    margin-top: 4px;
    border-top: 1px dashed #ddd;
    border-radius: 0;
    font-style: italic;
    color: #555;
`;

export const ManualModeRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const SwitchModeLink = styled.button`
    border: none;
    background: none;
    padding: 0;
    font-size: 12px;
    font-weight: 700;
    color: #666;
    text-decoration: underline;
    cursor: pointer;
`;
